<template>
  <div>
    <b-row>
      <!-- MQSERIES -->
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="name" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.config_name')" :placeholderValue="$t('common.routing.config_name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="host" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.host')" :placeholderValue="$t('common.routing.host')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="port" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.port')" :placeholderValue="$t('common.routing.port')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="formatName != '' && formatOutName != ''">
        <form-write-group-label-input v-model="formatName" isMandatory  disabled
          :inputLabel="$t('common.routing.format_name')" :placeholderValue="$t('common.routing.format_name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="formatName != '' && formatOutName != ''">
        <form-write-group-label-input v-model="formatOutName" isMandatory disabled
          :inputLabel="$t('common.routing.format_out_name')" :placeholderValue="$t('common.routing.format_out_name')">
        </form-write-group-label-input>
      </b-col>
<!--      <b-col sm="6" class="form-group">-->
<!--        <form-write-group-label-input v-model="connectionMode" isMandatory :disabled="readonly"-->
<!--          :inputLabel="$t('common.routing.connection_mode')" :placeholderValue="$t('common.routing.connection_mode')">-->
<!--        </form-write-group-label-input>-->
<!--      </b-col>-->
<!--      <b-col sm="6" class="form-group">-->
<!--        <form-write-group-label-input v-model="connectionType" isMandatory :disabled="readonly"-->
<!--          :inputLabel="$t('common.routing.connection_type')" :placeholderValue="$t('common.routing.connection_type')">-->
<!--        </form-write-group-label-input>-->
<!--      </b-col>-->

      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="login" :disabled="readonly"
                                      :inputLabel="$t('common.routing.login')" :placeholderValue="$t('common.routing.login')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="password" :disabled="readonly"
                                      :inputLabel="$t('common.routing.password')" :placeholderValue="$t('common.routing.password')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="peerName" :disabled="readonly"
                                      :inputLabel="$t('common.routing.peer_name')" :placeholderValue="$t('common.routing.peer_name')">
        </form-write-group-label-input>
      </b-col>
<!--      <b-col sm="6" class="form-group">-->
<!--        <form-write-group-label-input v-model="repository" isMandatory disabled-->
<!--                                      :inputLabel="$t('common.routing.repository')" :placeholderValue="$t('common.routing.repository')">-->
<!--        </form-write-group-label-input>-->
<!--      </b-col>-->
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="timeout" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.timeout')" :placeholderValue="$t('common.routing.timeout')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="queueManager" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.queue_manager')" :placeholderValue="$t('common.routing.queue_manager')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="channelName" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.channel_name')" :placeholderValue="$t('common.routing.channel_name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="queueName" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.queue_name')" :placeholderValue="$t('common.routing.queue_name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <label for="ssl-active">
          {{ $t('common.routing.ssl_active') }}<span class="color-red"> * </span>
        </label>
        <select class="form-control" v-model="sslActive" :disabled="readonly" id="ssl-active">
          <option value="1"> {{ $t('common.routing.yes') }} </option>
          <option value="0"> {{ $t('common.routing.no') }} </option>
        </select>
      </b-col>
      <b-col sm="6" class="form-group" v-if="!readonly && sslActive == 1">
        <label for="ssl-active">
          {{ $t('common.routing.file_kdb') }}
        </label>
        <input type="file" @change="handleFileUploadCertificat('kdb', $event)" accept=".kdb " />
      </b-col>
      <b-col sm="6" class="form-group" v-if="!readonly && sslActive == 1">
        <label for="ssl-active">
          {{ $t('common.routing.file_sth') }}
        </label>
        <input type="file" @change="handleFileUploadCertificat('sth', $event)" accept=".sth" />
      </b-col>
<!--      <b-col v-if="sslActive != '0'" sm="6" class="form-group">-->
<!--        <label for="keystore">-->
<!--          {{ $t('common.routing.keystore') }}<span class="color-red"> * </span>-->
<!--        </label>-->
<!--        <select class="form-control" v-model="keystore" :disabled="readonly" id="keystore">-->
<!--          <option v-for="keystore in keystoreList" :key="keystore.id" :value="keystore.id"> {{ keystore.name }} </option>-->
<!--        </select>-->
<!--      </b-col>-->
<!--      <b-col sm="6" v-if="sslActive != '0'" class="form-group">-->
<!--        <label for="ca">-->
<!--          {{ $t('common.routing.certificat') }}-->
<!--&lt;!&ndash;          <span class="color-red"> * </span>&ndash;&gt;-->
<!--        </label>-->
<!--        <select class="form-control" v-model="ca" :disabled="readonly" id="ca">-->
<!--          <option v-for="ca in caList" :key="ca.id" :value="ca.id"> {{ ca.name }} </option>-->
<!--        </select>-->
<!--      </b-col>-->
    </b-row>
    <level-control-form v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="controlConfig" :placementLevel="placementMQSeries"></level-control-form>
    <form-accordion :title="$t('common.vop_provider.vop_provider')" :isTitleUpperCase="false" v-if="entitiesType === 'rvm'">
      <b-row class="form-group">
        <b-col sm="6" class="form-group">
          <label for="vopProvider">
            {{ $t('common.vop_provider.name') }}<span class="color-red"> * </span>
          </label>
          <select class="form-control" v-model="IdVopProvider" :disabled="readonly"  id="vopProvider">
            <option value="" hidden disabled> {{ $t('common.routing.select_name_vop_provider') }} </option>
            <option v-for="vopProvider in vopProviderList" :key="vopProvider.id" :value="vopProvider.id">
              {{ vopProvider.text }}
            </option>
          </select>
        </b-col>
      </b-row>
    </form-accordion>
<!--    <certificate-form-global v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="certificateConfig" :placementCertificate="placementMQSeries"></certificate-form-global>-->
<!--    <private-keys-form-global v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="privateKeysConfig" :placementPrivateKey="placementMQSeries"></private-keys-form-global>-->
  </div>
</template>
<script>
import CertificateFormGlobal from '@/pages/routing/global/CertificateFormGlobal.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import LevelControlForm from '@/pages/routing/global/LevelControlForm.vue'
import PrivateKeysFormGlobal from '@/pages/routing/global/PrivateKeysFormGlobal.vue'
import FormReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import {errorMessageAlert} from '@/helpers/alert'
import FormAccordion from '@/components/common/FormAccordion.vue'

export default {
  name: 'MQSeriesCredentialForm',
  components: {
    FormReadGroupLabelInput,
    'certificate-form-global': CertificateFormGlobal,
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'level-control-form' : LevelControlForm,
    'private-keys-form-global': PrivateKeysFormGlobal
  },
  props: {
    mode: {
      type: String,
      default: "create"
    },
    placementMQSeries: {
      type: Number,
      default: -1
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }

  },
  computed:{
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    formatOutName:{
      get () {
        return this.inputValue.formatOutName
      },
      set (val) {
        this.inputValue = {
          formatOutName: val,
          formatName: this.inputValue.formatName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          timeout: this.inputValue.timeout,
          login: this.inputValue.login,
          password: this.inputValue.password,
          peerName: this.inputValue.peerName,
          repository: this.inputValue.repository,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: this.inputValue.kdb,
          sth: this.inputValue.sth,
        }
      }
    },
    formatName:{
      get () {
        return this.inputValue.formatName
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: val,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          timeout: this.inputValue.timeout,
          login: this.inputValue.login,
          password: this.inputValue.password,
          peerName: this.inputValue.peerName,
          repository: this.inputValue.repository,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: this.inputValue.kdb,
          sth: this.inputValue.sth,
        }
      }
    },
    name:{
      get () {
        return this.inputValue.name
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: this.inputValue.formatName,
          name: val,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          timeout: this.inputValue.timeout,
          login: this.inputValue.login,
          password: this.inputValue.password,
          peerName: this.inputValue.peerName,
          repository: this.inputValue.repository,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: this.inputValue.kdb,
          sth: this.inputValue.sth,
        }
      }
    },
    host:{
      get () {
        return this.inputValue.host
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: this.inputValue.formatName,
          name: this.inputValue.name,
          host: val,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          timeout: this.inputValue.timeout,
          login: this.inputValue.login,
          password: this.inputValue.password,
          peerName: this.inputValue.peerName,
          repository: this.inputValue.repository,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: this.inputValue.kdb,
          sth: this.inputValue.sth,
        }
      }
    },
    port:{
      get () {
        return this.inputValue.port
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: this.inputValue.formatName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: val,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          timeout: this.inputValue.timeout,
          login: this.inputValue.login,
          password: this.inputValue.password,
          peerName: this.inputValue.peerName,
          repository: this.inputValue.repository,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: this.inputValue.kdb,
          sth: this.inputValue.sth,
        }
      }
    },
    sslActive:{
      get () {
        return this.inputValue.sslActive === undefined ? '' : this.inputValue.sslActive
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: this.inputValue.formatName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: val,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          timeout: this.inputValue.timeout,
          login: this.inputValue.login,
          password: this.inputValue.password,
          peerName: this.inputValue.peerName,
          repository: this.inputValue.repository,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: this.inputValue.kdb,
          sth: this.inputValue.sth,
        }
      }
    },
    connectionMode:{
      get () {
        return this.inputValue.connectionMode
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: this.inputValue.formatName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: val,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          timeout: this.inputValue.timeout,
          login: this.inputValue.login,
          password: this.inputValue.password,
          peerName: this.inputValue.peerName,
          repository: this.inputValue.repository,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: this.inputValue.kdb,
          sth: this.inputValue.sth,
        }
      }
    },
    connectionType:{
      get () {
        return this.inputValue.connectionType
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: this.inputValue.formatName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: val,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          timeout: this.inputValue.timeout,
          login: this.inputValue.login,
          password: this.inputValue.password,
          peerName: this.inputValue.peerName,
          repository: this.inputValue.repository,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: this.inputValue.kdb,
          sth: this.inputValue.sth,
        }
      }
    },
    queueManager:{
      get () {
        return this.inputValue.queueManager
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: this.inputValue.formatName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: val,
          channelName: this.inputValue.channelName,
          timeout: this.inputValue.timeout,
          login: this.inputValue.login,
          password: this.inputValue.password,
          peerName: this.inputValue.peerName,
          repository: this.inputValue.repository,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: this.inputValue.kdb,
          sth: this.inputValue.sth,
        }
      }
    },
    channelName:{
      get () {
        return this.inputValue.channelName
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: this.inputValue.formatName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: val,
          timeout: this.inputValue.timeout,
          login: this.inputValue.login,
          password: this.inputValue.password,
          peerName: this.inputValue.peerName,
          repository: this.inputValue.repository,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: this.inputValue.kdb,
          sth: this.inputValue.sth,
        }
      }
    },
    timeout:{
      get () {
        return this.inputValue.timeout
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: this.inputValue.formatName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          timeout: val,
          login: this.inputValue.login,
          password: this.inputValue.password,
          peerName: this.inputValue.peerName,
          repository: this.inputValue.repository,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: this.inputValue.kdb,
          sth: this.inputValue.sth,
        }
      }
    },
    login:{
      get () {
        return this.inputValue.login
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: this.inputValue.formatName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          timeout: this.inputValue.timeout,
          login: val,
          password: this.inputValue.password,
          peerName: this.inputValue.peerName,
          repository: this.inputValue.repository,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: this.inputValue.kdb,
          sth: this.inputValue.sth,
        }
      }
    },
    password:{
      get () {
        return this.inputValue.password
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: this.inputValue.formatName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          timeout: this.inputValue.timeout,
          login: this.inputValue.login,
          password: val,
          peerName: this.inputValue.peerName,
          repository: this.inputValue.repository,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: this.inputValue.kdb,
          sth: this.inputValue.sth,
        }
      }
    },
    peerName:{
      get () {
        return this.inputValue.peerName
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: this.inputValue.formatName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          timeout: this.inputValue.timeout,
          login: this.inputValue.login,
          password: this.inputValue.password,
          peerName: val,
          repository: this.inputValue.repository,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: this.inputValue.kdb,
          sth: this.inputValue.sth,
        }
      }
    },
    repository:{
      get () {
        return this.inputValue.repository
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: this.inputValue.formatName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          timeout: this.inputValue.timeout,
          login: this.inputValue.login,
          password: this.inputValue.password,
          peerName: this.inputValue.peerName,
          repository: val,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: this.inputValue.kdb,
          sth: this.inputValue.sth,
        }
      }
    },
    queueName:{
      get () {
        return this.inputValue.queueName
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: this.inputValue.formatName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          timeout: this.inputValue.timeout,
          login: this.inputValue.login,
          password: this.inputValue.password,
          peerName: this.inputValue.peerName,
          repository: this.inputValue.repository,
          queueName: val,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: this.inputValue.kdb,
          sth: this.inputValue.sth,
        }
      }
    },
    controlConfig:{
      get () {
        return this.inputValue.controlConfig
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: this.inputValue.formatName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          timeout: this.inputValue.timeout,
          login: this.inputValue.login,
          password: this.inputValue.password,
          peerName: this.inputValue.peerName,
          repository: this.inputValue.repository,
          queueName: this.inputValue.queueName,
          controlConfig: val,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: this.inputValue.kdb,
          sth: this.inputValue.sth,
        }
      }
    },
    certificateConfig:{
      get () {
        return this.inputValue.certificateConfig
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: this.inputValue.formatName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          timeout: this.inputValue.timeout,
          login: this.inputValue.login,
          password: this.inputValue.password,
          peerName: this.inputValue.peerName,
          repository: this.inputValue.repository,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: val,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: this.inputValue.kdb,
          sth: this.inputValue.sth,
        }
      }
    },
    privateKeysConfig:{
      get () {
        return this.inputValue.privateKeysConfig
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: this.inputValue.formatName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          timeout: this.inputValue.timeout,
          login: this.inputValue.login,
          password: this.inputValue.password,
          peerName: this.inputValue.peerName,
          repository: this.inputValue.repository,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: val,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: this.inputValue.kdb,
          sth: this.inputValue.sth,
        }
      }
    },
    keystore:{
      get () {
        return this.inputValue.keystore
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: this.inputValue.formatName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          timeout: this.inputValue.timeout,
          login: this.inputValue.login,
          password: this.inputValue.password,
          peerName: this.inputValue.peerName,
          repository: this.inputValue.repository,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: val,
          ca: this.inputValue.ca,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: this.inputValue.kdb,
          sth: this.inputValue.sth,
        }
      }
    },
    ca:{
      get () {
        return this.inputValue.ca
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: this.inputValue.formatName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          timeout: this.inputValue.timeout,
          login: this.inputValue.login,
          password: this.inputValue.password,
          peerName: this.inputValue.peerName,
          repository: this.inputValue.repository,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: this.inputValue.keystore,
          ca: val,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: this.inputValue.kdb,
          sth: this.inputValue.sth,
        }
      }
    },
    IdVopProvider:{
      get () {
        return this.inputValue.IdVopProvider === undefined ? '' : this.inputValue.IdVopProvider
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: this.inputValue.formatName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          timeout: this.inputValue.timeout,
          login: this.inputValue.login,
          password: this.inputValue.password,
          peerName: this.inputValue.peerName,
          repository: this.inputValue.repository,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          IdVopProvider: val,
          kdb: this.inputValue.kdb,
          sth: this.inputValue.sth,
        }
      }
    },
    kdb:{
      get () {
        return this.inputValue.kdb
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: this.inputValue.formatName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          timeout: this.inputValue.timeout,
          login: this.inputValue.login,
          password: this.inputValue.password,
          peerName: this.inputValue.peerName,
          repository: this.inputValue.repository,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: val,
          sth: this.inputValue.sth,
        }
      }
    },
    sth:{
      get () {
        return this.inputValue.sth
      },
      set (val) {
        this.inputValue = {
          formatOutName: this.inputValue.formatOutName,
          formatName: this.inputValue.formatName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          sslActive: this.inputValue.sslActive,
          connectionMode: this.inputValue.connectionMode,
          connectionType: this.inputValue.connectionType,
          queueManager: this.inputValue.queueManager,
          channelName: this.inputValue.channelName,
          timeout: this.inputValue.timeout,
          login: this.inputValue.login,
          password: this.inputValue.password,
          peerName: this.inputValue.peerName,
          repository: this.inputValue.repository,
          queueName: this.inputValue.queueName,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          IdVopProvider: this.inputValue.IdVopProvider,
          kdb: this.inputValue.kdb,
          sth: val
        }
      }
    },
  },
  data () {
    return {
      caList: [],
      keystoreList: [],
      vopProviderList: []
    }
  },
  created () {
    this.entitiesType = this.$route.params.entitiesType
    this.getCA()
    this.getKeyStore()
    this.getVopProvider()
    if (this.mode === 'create') {
      this.inputValue.sslActive = "0"
    }
  },
  methods: {
    getCA () {
      let that = this
      this.$engine.security.ca.fetch()
      .then(resp => {
        let CAList = {}

        CAList = resp.data.ca
        this.caList = CAList
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getKeyStore () {
      let that = this
      this.$engine.security.keystore.fetch()
      .then(resp => {
        let privateKeysList = {}

        privateKeysList = resp.data.keystore

        this.keystoreList = privateKeysList
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    handleFileUploadCertificat(type, event) {
      const file = event.target.files[0]
      if (!file) return

      const reader = new FileReader()
      reader.readAsDataURL(file)

      reader.onload = () => {
        this.inputValue[type] = reader.result.split(',')[1]
      }

      reader.onerror = error => {
        console.error("Erreur de lecture du fichier:", error)
      }
    },
    getVopProvider () {
      let params = {}
      let that = this
      this.$engine.vopProvider.getVopProvider(params).then((resp) => {
        this.vopProviderList = resp.data.VopProvider.map(vopProvider => ({
          id: vopProvider.IdVopProvider,
          text: vopProvider.NameVopProvider,
          value: vopProvider.NameVopProvider
        }))
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    }
  }
}
</script>
